import * as React from "react";
import { Tabs } from "react-ui";

import { printErrorLog } from "../../Tour/Steps/PrintErrorLog/PrintErrorLog";
import { PanelTabType } from "../PanelTypes";
import { useTourStepRef } from "../../../Internals/TourManagement/UseTourStepRef";
import { extendedErrorLog } from "../../Tour/Steps/ExtendedErrorLog/ExtendedErrorLog";

import { CounterContainer } from "./Counter/CounterContainer";
import { PanelTab, PanelTabContent, tabsMarginFix } from "./PanelTabs.styles";

export interface PanelTabsProps {
    className?: string;
    active: PanelTabType;
    onChange: (value: PanelTabType) => void;
    counterEnabled: boolean;
    counterCount: number;
    useExtendedErrorLog: boolean;
    isReadOnly?: boolean;
}

export function PanelTabs(props: PanelTabsProps): JSX.Element {
    const tourRef = useTourStepRef(props.useExtendedErrorLog ? extendedErrorLog : printErrorLog);
    if (props.isReadOnly) {
        return <></>;
    }
    const handleChange = (value: string) => {
        if (value === "menu") {
            props.onChange("menu");
        } else if (value === "check") {
            props.onChange("check");
        } else {
            throw new Error("Not supported tab type");
        }
    };

    return (
        <Tabs
            css={tabsMarginFix}
            className={props.className}
            value={props.active}
            onValueChange={handleChange}
            ref={tourRef}>
            <PanelTab id="menu" component="span" href="none">
                <PanelTabContent>Разделы</PanelTabContent>
            </PanelTab>
            <PanelTab id="check" component="span" href="none">
                <PanelTabContent>
                    Проверка
                    {props.counterEnabled && <CounterContainer count={props.counterCount} />}
                </PanelTabContent>
            </PanelTab>
        </Tabs>
    );
}
